import { render, staticRenderFns } from "./OcpbCareTrackingButton.vue?vue&type=template&id=417c3159&"
import script from "./OcpbCareTrackingButton.vue?vue&type=script&lang=js&"
export * from "./OcpbCareTrackingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports